var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breadList && _vm.breadList.length)?_c('div',{staticClass:"bread-x"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadList),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: item.link }}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }